module.exports = __webpack_public_path__ + "media/images/emblems/Diemtigen-coat_of_arms-40d4fa766d90d3b1d515964ea5572d30.svg";